import { useState } from 'react';
import { Modal } from '../modal/PersonaModal';
import { ResultCard } from './ResultCard';
import { ResultCardListProps } from './types/result-card.types';
import { ResultItem } from '../modal/types/persona-modal.types';

export const ResultCardList = ({ personaData = [], categoryTitles = [] }: ResultCardListProps) => {
    const [selectedCard, setSelectedCard] = useState<ResultItem | null>(null);


    // If no persona data provided, fallback to mock data
	const displayData = personaData.length > 0
		? personaData.map((persona, index) => {
                
                const infoBlocks = persona.contentSections
                    ? Object.entries(persona.contentSections)
                          .filter(([title]) =>
                              title !== 'Persona Name' &&
                              title !== 'Tagline' &&
                              !title.endsWith('_icon')
                          )
                          .map(([title, content]) => {
                              const iconHtml = persona.contentSections?.[`${title}_icon`];

                              return {
                                  title,
                                  content,
                                  iconHtml: iconHtml || null, 
                              };
                          })
                    : [];

                const tagline = persona.contentSections?.['Tagline'] ||
                               persona.personaDetails?.tagline ||
                               '';

                const subtitle = persona.contentSections?.['Persona Name'] ||
                                persona.resultLabel ||
                                persona.resultLabelEn ||
                                'Unknown Persona';

                return {
                    title: categoryTitles[index] || `Category ${index + 1}`,
                    image: persona.resultIcon || 'https://via.placeholder.com/70x55',
                    subtitle,
                    resultColor: persona.resultColor,
                    resultCode: persona.resultCode,
                    infoBlocks,
                    tagline,
                    catNumber: index + 1,
                };
            })
		: null;

	return (
		<>
			<div className="w-full grid min-[1280px]:grid-cols-4 min-[512px]:grid-cols-3 grid-cols-2 justify-start items-stretch gap-1.5">
				{displayData?.map((item, index) => (
					<ResultCard
						key={item.title || index}
						{...item}
						onClick={() => setSelectedCard(item)}
					/>
				))}
			</div>

			<Modal
                isOpen={!!selectedCard}
                onClose={() => setSelectedCard(null)}
                result={selectedCard}
                />
		</>
	);
};
